import type { FuncionarioResumo } from "@/lib/envio-colaborador-api";

type Passo = "identificacao" | "atestado" | "recibo";
export type TipoAtestado = "digital" | "fisico";

export interface Estado {
  passo: Passo;
  token: string | null;
  funcionario: FuncionarioResumo | null;
  tipo: TipoAtestado | null;
  arquivo: File | null;
  digitalValido: boolean | null;
  protocolo: string | null;
  aviso: string | null;
}

export type Acao =
  | {
      t: "identificado";
      token: string;
      funcionario: FuncionarioResumo;
    }
  | { t: "escolherTipo"; tipo: TipoAtestado }
  | { t: "voltar" }
  | { t: "arquivo"; arquivo: File; digitalValido: boolean | null }
  | { t: "removerArquivo" }
  | { t: "enviado"; protocolo: string }
  | { t: "sessaoExpirada" }
  | { t: "envioJaConcluido"; mensagem: string }
  | { t: "novoEnvio" };

const AVISO_DIGITAL_INVALIDO =
  "Este arquivo não é um atestado digital válido. Ele será enviado como atestado físico e o RH confere.";
export const AVISO_SESSAO_EXPIRADA = "Sessão expirada. Comece de novo.";

export const estadoInicial: Estado = {
  passo: "identificacao",
  token: null,
  funcionario: null,
  tipo: null,
  arquivo: null,
  digitalValido: null,
  protocolo: null,
  aviso: null,
};

const semArquivo = { arquivo: null, digitalValido: null, aviso: null };

export function reduzir(e: Estado, a: Acao): Estado {
  switch (a.t) {
    case "identificado":
      return {
        ...e,
        passo: "atestado",
        token: a.token,
        funcionario: a.funcionario,
        aviso: null,
      };
    case "escolherTipo":
      return { ...e, tipo: a.tipo, ...semArquivo };
    case "arquivo":
      // a verificação do digital é assíncrona: se a pessoa saiu do passo nesse meio-tempo, descarta
      if (e.passo !== "atestado" || !e.tipo) return e;
      if (e.tipo === "digital" && a.digitalValido === false) {
        return {
          ...e,
          tipo: "fisico",
          arquivo: a.arquivo,
          digitalValido: false,
          aviso: AVISO_DIGITAL_INVALIDO,
        };
      }
      return {
        ...e,
        arquivo: a.arquivo,
        digitalValido: a.digitalValido,
        aviso: null,
      };
    case "removerArquivo":
      return { ...e, ...semArquivo };
    case "enviado":
      return {
        ...e,
        passo: "recibo",
        protocolo: a.protocolo,
        token: null,
        aviso: null,
      };
    case "sessaoExpirada":
      return { ...estadoInicial, aviso: AVISO_SESSAO_EXPIRADA };
    case "envioJaConcluido":
      return { ...estadoInicial, aviso: a.mensagem };
    case "novoEnvio":
      // Outro atestado: identifica de novo (o token anterior já foi usado).
      return estadoInicial;
    case "voltar":
      if (e.passo !== "atestado") return e;
      if (e.tipo) return { ...e, tipo: null, ...semArquivo };
      return { ...estadoInicial };
  }
}

export function numeroDoPasso(p: Passo): 1 | 2 | null {
  return ({ identificacao: 1, atestado: 2, recibo: null } as const)[p];
}
